export function getMandantId() {
	let mandantId = "";
	try {
		mandantId = document.querySelector("[name='mandant']").content;
	} catch (e) {
		mandantId = document.body.getAttribute('data-mandant');
	}
	return mandantId;
}